<template>
  <v-container class="card vld-parent">
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <v-row v-if="mostrarParametros">
      <v-col class="pb-2" cols="12" md="12">
        <v-select
          v-if="parametrosCoac"
          :items="parametrosCoac.creditos"
          item-text="tipoCredito"
          item-value="idCredito"
          prepend-inner-icon="mdi-bank-transfer-out"
          label="Tipo de Crédito"
          v-model="$v.calculadora.tipoCredito.$model"
          required
          :error-messages="tipoCreditoError"
          dense
          @change="onTipoCreditoChange"
        ></v-select>
      </v-col>
      <v-col class="pb-2" cols="12" md="12">
        <v-text-field
          type="number"
          v-if="parametrosCoac"
          prepend-inner-icon="mdi-cash-100"
          :label="labelMontoSolicitar"
          v-model="$v.calculadora.montoSolicitado.$model"
          required
          :error-messages="montoSolicitadoError"
          dense
        ></v-text-field>
      </v-col>
      <v-col class="pb-2" cols="12" md="12">
        <v-text-field
          type="number"
          v-if="parametrosCoac"
          prepend-inner-icon="mdi-calendar-month"
          :label="labelPlazoMeses"
          v-model="$v.calculadora.plazoMeses.$model"
          required
          :error-messages="plazoMesesError"
          dense
        ></v-text-field>
      </v-col>
      <v-col class="pb-2" cols="12" md="12">
        <v-select
          v-if="parametrosCoac"
          :items="parametrosCoac.cuotas"
          item-text="nombreCuota"
          item-value="idCuota"
          prepend-inner-icon="mdi-piggy-bank"
          label="Tipo de Cuota"
          v-model="$v.calculadora.tipoCuota.$model"
          required
          :error-messages="tipoCuotaError"
          dense
        ></v-select>
      </v-col>
    </v-row>
    <v-row v-if="mostrarParametros">
      <v-col class="pt-0">
        <v-btn
          v-if="parametrosCoac"
          block
          depressed
          dense
          :color="parametrosCoac.colorSecundario"
          dark
          @click="onCalcularCreditoClick"
        >
          <v-icon right dark> mdi-calculator </v-icon>&nbsp; CALCULAR CRÉDITO</v-btn
        >
      </v-col>
    </v-row>
    <span id="printMe">
      <v-row v-if="prestamoCalculado">
        <v-col class="col-md-12 col-sm-12">
          <v-card class="mx-auto" outlined>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td class="text-left font-weight-medium">
                        <Tooltip texto="Es el monto de crédito otorgado"></Tooltip>
                        MONTO FINANCIADO
                      </td>
                      <td class="text-left">
                        {{ prestamoCalculado.totalCapital }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-left font-weight-medium">
                        <Tooltip
                          texto="Es el monto intereses que paga el socio durante la vigencia del crédito"
                        ></Tooltip>
                        INTERÉS
                      </td>
                      <td class="text-left">
                        {{ prestamoCalculado.totalInteres }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-left font-weight-medium">
                        <Tooltip
                          texto="Es el monto pagado por seguro en caso de fallecimiento del socio"
                        ></Tooltip>
                        SEGURO DESGRAVAMEN
                      </td>
                      <td class="text-left">
                        {{ prestamoCalculado.totalSeguroDesgravamen }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-left font-weight-medium">
                        <Tooltip
                          texto="La suma total de los intereses más el seguro de desgravamen que paga el socio durante la vigencia del crédito"
                        ></Tooltip>
                        TOTAL CARGA FINANCIERA
                      </td>
                      <td class="text-left">
                        {{ prestamoCalculado.totalCargaFinanciera }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-left font-weight-medium">
                        <Tooltip
                          texto="La suma del monto del crédito más la carga financiera"
                        ></Tooltip>
                        SUMA TOTAL CUOTAS
                      </td>
                      <td class="text-left">
                        {{ prestamoCalculado.totalCuotas }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-left font-weight-medium">
                        <Tooltip texto="La tasa de interés anual aplicada al crédito"></Tooltip>
                        TASA NOMINAL
                      </td>
                      <td class="text-left">
                        {{ prestamoCalculado.tasaNominal }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-left font-weight-medium">
                        <Tooltip
                          texto="La tasa del interés de la operación según el número de períodos de pago al año"
                        ></Tooltip>
                        TASA EFECTIVA
                      </td>
                      <td class="text-left">
                        {{ prestamoCalculado.tasaEfectiva }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-row v-if="prestamoCalculado">
                <v-col class="pt-5">
                  <v-alert border="bottom" type="warning" dark v-if="prestamoCalculado.teaValor">
                    Por favor, amplíe el plazo en meses de su prestamo
                  </v-alert>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="prestamoCalculado">
        <v-col v-if="prestamoCalculado.teaValor == false">
          <v-row>
            <v-col class="text-h4">TABLA DE AMORTIZACIÓN</v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-simple-table fixed-header>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">NUM PAGO</th>
                      <th class="text-left">FECHA</th>
                      <th class="text-left">CAPITAL</th>
                      <th class="text-left">INTERÉS</th>
                      <th class="text-left">CAPITAL DIVIDENDO</th>
                      <th class="text-left">CAPITAL REDUCIDO</th>
                      <th class="text-left">SEGURO DESGRAV.</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="cuota in prestamoCalculado.creditoCuotas" :key="cuota.numPago">
                      <td>{{ cuota.numPago }}</td>
                      <td>{{ cuota.fecha }}</td>
                      <td>{{ cuota.capital }}</td>
                      <td>{{ cuota.interes }}</td>
                      <td>{{ cuota.capitalDividendo }}</td>
                      <td>{{ cuota.capitalReducido }}</td>
                      <td>{{ cuota.seguroDesgravamen }}</td>
                    </tr>
                  </tbody>
                  <tfoot class="grey">
                    <tr class="pb-5 pt-5">
                      <td colspan="2" class="font-weight-bold">TOTALES</td>
                      <td class="pl-4 font-weight-bold">${{ prestamoCalculado.totalCapital }}</td>
                      <td class="pl-4 font-weight-bold">${{ prestamoCalculado.totalInteres }}</td>
                      <td class="pl-4 font-weight-bold">
                        ${{ prestamoCalculado.totalCapitalDividendo }}
                      </td>
                      <td class="pl-4 font-weight-bold">
                        {{ prestamoCalculado.totalCapitalReducido }}
                      </td>
                      <td class="pl-4 font-weight-bold">
                        ${{ prestamoCalculado.totalSeguroDesgravamen }}
                      </td>
                    </tr>
                  </tfoot>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </span>
    <v-row v-if="prestamoCalculado">
      <v-col class="pt-2">
        <v-btn
          v-if="parametrosCoac"
          block
          depressed
          dense
          :color="parametrosCoac.colorSecundario"
          dark
          @click="onImprimirClick"
        >
          <v-icon right dark> mdi-printer </v-icon>&nbsp; IMPRIMIR</v-btn
        >
      </v-col>
      <v-col class="pt-2">
        <v-btn
          v-if="parametrosCoac"
          block
          depressed
          dense
          color="grey"
          @click="onCalcularNuevamenteClick"
        >
          <v-icon right dark> mdi-calculator </v-icon>&nbsp; CALCULAR NUEVAMENTE</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { required, decimal, numeric } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import Tooltip from "./Tooltip";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "Parametros",
  components: { Tooltip, Loading },
  data: () => ({
    calculadora: {
      montoSolicitado: "",
      plazoMeses: "",
      tipoCredito: "",
      tipoCuota: "",
      tasaEfectivaAnual: "",
    },
    labelPlazoMeses: "Plazo en meses",
    labelMontoSolicitar: "Monto a solicitar",
    fullPage: true,
    mostrarParametros: true,
  }),
  watch: {
    "calculadora.plazoMeses": function (val) {
      if (!val) {
        this.labelPlazoMeses = "Plazo en meses ";
        return;
      }

      let montoCredito;
      const credito = this.parametrosCoac.creditos.find(
        (p) => p.idCredito === this.calculadora.tipoCredito
      );
      console.log("El credito", credito);
      if (credito) {
        const montoSolicitado = this.calculadora.montoSolicitado;
        montoCredito = credito.montosCredito.find(
          (mc) =>
            parseInt(montoSolicitado) <= parseInt(mc.montoMaximo) &&
            parseInt(montoSolicitado) >= parseInt(mc.montoMinimo)
        );
      }
      if (montoCredito) this.labelPlazoMeses = "Plazo en meses " + montoCredito.tiempoMaximo;
    },

    "calculadora.montoSolicitado": function (val) {
      const credito = this.parametrosCoac.creditos.find(
        (p) => p.idCredito === this.calculadora.tipoCredito
      );

      if (parseInt(val) > parseInt(credito.montoMaximo)) {
        this.labelMontoSolicitar = "Monto a solicitar debe ser menor a " + credito.montoMaximo;
      } else if (parseInt(val) < parseInt(credito.montoMinimo)) {
        this.labelMontoSolicitar = "Monto a solicitar debe ser mayor a " + credito.montoMinimo;
      } else {
        this.labelMontoSolicitar = "Monto a solicitar";
      }
    },
  },
  methods: {
    onTipoCreditoChange() {
      const credito = this.parametrosCoac.creditos.find(
        (p) => p.idCredito === this.calculadora.tipoCredito
      );
      if (credito) {
        console.log(credito.montoMaximo);
        this.labelMontoSolicitar =
          "Monto a solicitar, Monto mínimo: $" +
          credito.montoMinimo +
          " Monto máximo: $" +
          credito.montoMaximo;
      }
    },
    onCalcularCreditoClick() {
      this.$v.calculadora.$touch();
      if (this.$v.calculadora.$invalid) {
        return;
      }
      this.resetPrestamoCalculado();
      this.setPrestamoCalculado({
        capital: this.calculadora.montoSolicitado,
        plazo: this.calculadora.plazoMeses,
        tipoCredito: this.calculadora.tipoCredito,
        tipoCuota: this.calculadora.tipoCuota,
      });
      this.mostrarParametros = false;
    },
    async onImprimirClick() {
      await this.$htmlToPaper("printMe");
    },
    onCalcularNuevamenteClick() {
      this.mostrarParametros = true;
      this.resetPrestamoCalculado();
    },
    ...mapActions(["setPrestamoCalculado", "resetPrestamoCalculado"]),
  },

  computed: {
    ...mapGetters({
      prestamoCalculado: "getPrestamoCalculado",
      parametrosCoac: "getParametrosCoac",
      isLoading: "getIsLoading",
    }),
    montoSolicitadoError() {
      const errors = [];
      if (!this.$v.calculadora.montoSolicitado.$dirty) return errors;
      !this.$v.calculadora.montoSolicitado.required && errors.push("Ingrese el monto a solicitar");
      !this.$v.calculadora.montoSolicitado.decimal &&
        errors.push("Ingrese un monto a solicitar válido");
      return errors;
    },
    plazoMesesError() {
      const errors = [];
      if (!this.$v.calculadora.plazoMeses.$dirty) return errors;
      !this.$v.calculadora.plazoMeses.required && errors.push("Ingrese el plazo en meses");
      !this.$v.calculadora.plazoMeses.numeric && errors.push("Ingrese el número meses plazo ");
      return errors;
    },
    tipoCreditoError() {
      const errors = [];
      if (!this.$v.calculadora.tipoCredito.$dirty) return errors;
      !this.$v.calculadora.tipoCredito.required && errors.push("Seleccione el Tipo de Credito");
      return errors;
    },
    tipoCuotaError() {
      const errors = [];
      if (!this.$v.calculadora.tipoCuota.$dirty) return errors;
      !this.$v.calculadora.tipoCuota.required && errors.push("Seleccione el Tipo de Cuota");
      return errors;
    },
  },
  validations: {
    calculadora: {
      montoSolicitado: { required, decimal },
      plazoMeses: { required, numeric },
      tipoCredito: { required },
      tipoCuota: { required },
    },
  },
  mounted: function () {
    this.resetPrestamoCalculado();
  },
};
</script>
